module.exports = __webpack_public_path__ + "static/media/dave.b88d0615.jpeg";